import { ref, watch } from 'vue'

export const userTheme = ref(localStorage.getItem('user-theme') || 'light-theme')

watch(userTheme, (newTheme) => {
  localStorage.setItem('user-theme', newTheme)
  document.documentElement.className = newTheme
})
export function userThemeStore() {
  return {
    userTheme,
    toggleTheme: () => {
      userTheme.value = userTheme.value === 'dark-theme' ? 'light-theme' : 'dark-theme'
    },
  }
}
